module.exports = __webpack_public_path__ + "img/laravel-development.cd05907d.webp";